import LandingNav from "../../landing-page/components/LandingNav";
import Footer from "../../landing-page/components/Footer";
import { footerNavigation } from "../../landing-page/contentSections";

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <LandingNav />
      <main className="flex-grow pt-32 pb-16 px-6 lg:px-8 max-w-4xl mx-auto w-full">
        <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <p>Last updated: {new Date().toLocaleDateString()}</p>
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">1. Information We Collect</h2>
            <p>
              We collect information you provide directly to us, such as when you create an account,
              participate in any interactive features of our services, or communicate with us.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">2. How We Use Your Information</h2>
            <p>
              We use the information we collect to provide, maintain, and improve our services,
              to process transactions, and to send you technical notices and support messages.
            </p>
          </section>
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-3">3. Data Security</h2>
            <p>
              We take reasonable measures to help protect information about you from loss, theft,
              misuse and unauthorized access, disclosure, alteration and destruction.
            </p>
          </section>
        </div>
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
};
